import React from 'react';
import { Table } from 'semantic-ui-react';
import GlassmorphismTheme from '../../styles/glassmorphism';

interface GlassTableProps {
  children: React.ReactNode;
  [key: string]: any; // Para aceitar todas as props do Table original
}

const GlassTable: React.FC<GlassTableProps> = ({ children, ...props }) => {
  return (
    <div style={{
      ...GlassmorphismTheme.components.glassCard,
      background: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '12px',
      overflow: 'hidden', // Mantém hidden para preservar visual do card
      boxShadow: GlassmorphismTheme.shadows.glassSoft,
      position: 'relative' // Contexto de posicionamento
    }}>
      <Table 
        {...props}
        style={{
          ...props.style,
          background: 'transparent',
          margin: 0
        }}
      >
        {children}
      </Table>
    </div>
  );
};

export default GlassTable;
